var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zl_rate" }, [
    _c("div", { staticClass: "rateBox" }, [
      _c("span", {
        staticClass: "el-icon-close",
        on: { click: _vm.closeThis }
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "lottieDiv" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scoreandstar" },
        [
          _c("el-rate", {
            staticStyle: { "margin-bottom": "10px" },
            attrs: {
              disabled: "",
              colors: ["#ac7b36", "#ac7b36", "#ac7b36"],
              "score-template": "{value}"
            },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("我的得分")])
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "rateBtn", on: { click: _vm.handleClick } }, [
        _vm._v("进入下一节")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54fd816d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54fd816d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zl_rate.vue
// module id = null
// module chunks = 